import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_2 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_3 = {
  key: 2,
  class: "list-disc pl-6 space-y-1.5"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "inline-block rounded bg-gray-100 px-1.5 text-sm font-medium"
}

import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useCompensationPlanStore } from '../stores/useCompensationPlanStore';
import { parsePlanDescription } from '../utils/planDescription';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomPlanCard',
  setup(__props) {

const store = useCompensationPlanStore();
const { plan, loading } = storeToRefs(store);
const { handleError } = useSnackbarHandler();

const blocks = computed(() => parsePlanDescription(plan.value?.description));

onMounted(async () => {
  try {
    await store.loadPlan();
  } catch (error) {
    handleError(error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    class: "p-6 max-w-3xl",
    "data-cy": "custom-plan-card"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-baseline gap-3" }, [
        _createElementVNode("h4", { class: "m-0" }, "Compensation plan"),
        _createElementVNode("span", { class: "font-medium" }, "Custom")
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mt-2 text-gray-600" }, " Set up by LeanLaw for your firm. To change it, contact LeanLaw support. ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "mt-6 mb-2" }, "How this plan works", -1)),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Loading…"))
        : (!blocks.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " The plan description isn't available right now. Contact LeanLaw support. "))
          : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blocks.value, (block, i) => {
                return (_openBlock(), _createElementBlock("li", { key: i }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.segments, (segment, j) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                      (segment.bold)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(segment.text), 1))
                        : (segment.code)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(segment.text), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(segment.text), 1)
                            ], 64))
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            ]))
    ]),
    _: 1
  }))
}
}

})